<ul class="navbar-nav">
    <li class="nav-item">
        <a class="nav-link" (click)="onToggleMenuSidebar()" role="button"
            ><i class="fas fa-bars"></i
        ></a>
    </li>
</ul>

<ul class="navbar-nav ml-auto">
    <app-user></app-user>
</ul>